import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '01',
  title: 'The Mineral Reset',
  desc: "You'll start by flooding your system with the specific minerals your adrenals are starving for."
}, {
  num: '02',
  title: 'The 7-Day Window',
  desc: "You'll follow the Anti-Inflammatory Plate method to flatten your insulin and stop the bloat."
}, {
  num: '03',
  title: 'The Identity Shift',
  desc: 'You\'ll transition into a sustainable "80/20" lifestyle where your body works with you, not against you.'
}];
export const HowItWorks = () => {
  return <section className="py-24 bg-wellness-forest text-wellness-cream" data-id="element-54">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-56">
          <h2 className="text-4xl md:text-5xl mb-6" data-id="element-57">How It Works</h2>
          <div className="w-16 h-[1px] bg-wellness-gold mx-auto" data-id="element-58"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-12 relative" data-id="element-59">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[1px] bg-wellness-cream/20 -z-0" data-id="element-60"></div>

          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: idx * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-61">
              <div className="w-24 h-24 rounded-full bg-wellness-forest border border-wellness-gold flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(201,169,97,0.15)]" data-id="element-62">
                <span className="text-3xl font-serif text-wellness-gold italic" data-id="element-63">
                  {step.num}
                </span>
              </div>
              <h3 className="text-2xl mb-4" data-id="element-64">{step.title}</h3>
              <p className="font-sans font-light text-wellness-cream/70 leading-relaxed" data-id="element-65">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};